module.exports = __webpack_public_path__ + "media/application/images/iso-9001-c5d2319ad2b50940cea8f3437b4e2678.png";